import React from 'react';
import { CreateNewProgramRequestView } from './CreateNewProgramRequestView';
import { MergeRequestView } from './MergeRequestView';
import { ChangeStatusRequestView } from './ChangeStatusRequestView';
import { SplitRequestView } from './SplitRequestView';
import { ConsolidateRequestView } from './ConsolidateRequestView';
import { ChangeDetailsRequestView } from './ChangeDetailsRequestView';

const TYPE_CREATE_NEW = '1';
const TYPE_MERGE = '8';
const TYPE_CHANGE_STATUS = '6';
const TYPE_SPLIT = '7';
const TYPE_CONSOLIDATE = '10';
const CHANGE_DETAILS_TYPES = ['2', '3', '4', '5', '9', '11', '12'];

export const RequestDetailsRouter = ({ requestDetails, requestLogs }) => {
    const typeId = requestDetails?.typeId;

    if (typeId === TYPE_CREATE_NEW) {
        return <CreateNewProgramRequestView requestDetails={requestDetails} />;
    }
    if (typeId === TYPE_MERGE) {
        return <MergeRequestView requestDetails={requestDetails} requestLogs={requestLogs} />;
    }
    if (typeId === TYPE_CHANGE_STATUS) {
        return (
            <ChangeStatusRequestView
                requestDetails={requestDetails}
                requestLogs={requestLogs}
            />
        );
    }
    if (typeId === TYPE_SPLIT) {
        return <SplitRequestView requestDetails={requestDetails} requestLogs={requestLogs} />;
    }
    if (typeId === TYPE_CONSOLIDATE) {
        return (
            <ConsolidateRequestView
                requestDetails={requestDetails}
                requestLogs={requestLogs}
            />
        );
    }
    if (CHANGE_DETAILS_TYPES.includes(typeId)) {
        return (
            <ChangeDetailsRequestView
                requestDetails={requestDetails}
                requestLogs={requestLogs}
            />
        );
    }

    return (
        <div className="alert alert-warning">
            Unknown request type: {typeId}
        </div>
    );
};
